<template>
  <div class="carts">
    <section class="carts-top">
      <h1 class="carts-title">注文内容を確認・変更する</h1>
      <p class="carts-top__sentence">下の「注文を確定する」ボタンを押してご注文い ただくことで、お客様は当サイトの<a href="https://www.globeejapan.com/privacy_policy.html" target="_blank">プライバシーポリシー</a>および<a href="https://www.globeejapan.com/terms_of_service.html" target="_blank">利用規約</a>に同意の上、商品をご注文されたことになります。 </p>
      <p class="carts-top__sentence">Amazonマーケットプレイスの商品をご注文された場合、お客様は出品者の返品・交換の条件およびプライバシーポリシー、その他の販売条件、および一部の出品者から商品やサービスのご案内が届くことについても同意されたことになります。国内外の出品者の会社情報および所在並びに各条件・ポリシーの詳細は、出品者のページでご確認ください。</p>
      <p class="carts-top__sentence">Amazonマーケットプレイスの商品を購入する場合は、所定の配送料がかかります。「注文を確定する」ボタンをクリックする前に、配送料と注文合計をご確認ください。</p>
    </section>
    
    <section class="two-columns">
      <main class="two-columns__main">
        <div class="carts-contents carts-person">
          <section class="carts-person__contents person-info">
            <h2 class="person-info__ttl"><span>お届け先住所</span><a href="#">変更</a></h2>
            <p class="person-info__sentence">東京都 港区 東麻布1-7-3<br>第二渡邉ビル7F<br>電話番号: 070-1259-6034</p>
          </section>
          <section class="carts-person__contents person-info">
            <h2 class="person-info__ttl"><span>支払い方法</span><a href="#">変更</a></h2>
            <a href="#" class="person-payment is-active">
              <h3 class="person-payment__ttl">クレジットカード</h3>
              <div class="person-payment-card">
                <div class="person-payment-card__icon"><img src="/static/img/icon-credit.png" alt="" width="15"></div>
                <p class="person-payment-card__sentence">下4桁 5001</p>
              </div>
            </a>
            <a href="#" class="person-payment">
              <h3 class="person-payment__ttl">abceedポイント</h3>
              <p class="person-payment__sentence">手持ち: 2,000 pt</p>
            </a>
          </section>
        </div>

        <div class="carts-contents">
          <h2 class="scheduled-date-title">お届け予定日: 2019年5月11日~5月17日</h2>
          <ConfirmCard
            :imgUrl="'https://d3grtcc7imzgqe.cloudfront.net/img/book_small/tokyu_kinhure_new.jpg'"
            :title="'TOEIC L&R TEST 出る特急 金のフレーズ'"
            :author="'TEX加藤(著)'"
            :price="'890'"
            :priceTax="'961'"
            :point="'89'"
            :pointRate="'10'"
            :ammount="'1'"
            :store="'株式会社Globee'"
          />
        </div>
      </main>
      <section class="two-columns__side">
        <div class="order-area">
          <div class="order-area__submit"><a href="#" class="btn-square">注文を確定する</a></div>
          <section class="order-main">
            <p class="order-main__ttl">注文内容</p>
            <div class="order-detail">
              <p>商品の小計：</p>
              <p>¥ 961</p>
            </div>
            <div class="order-detail">
              <p>配送料・手数料：</p>
              <p>¥ 400</p>
            </div>
            <section class="order-sum">
              <p>ご請求額</p>
              <p class="order-sum__price">¥ 1,361</p>
            </section>
          </section>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
  import ConfirmCard from './parts/ConfirmCard.vue';

  export default {
    title: '注文内容を確認・変更する | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: '注文内容を確認・変更する',
    description: '',
    keywords: 'toeic,abceed,abceed analytics premium,globee,注文内容を確認・変更する',
    headerType: 'historyBack',
    components: { ConfirmCard },
    data() {
      return {
      }
    },
    methods: {
    },
  }
</script>

<style scoped lang="scss">
  .carts-top {
    width: 800px;
    margin: 0 auto;
    padding: 20px 0 0;
    @media screen and (max-width: 768px){
      width: auto;
      padding: 20px 15px 0;
    }
    &__sentence {
      text-align: justify;
      margin-bottom: 12px;
      a {
        color: #FF5B60;
      }
    }
  }
    
  .carts-title {
    font-size: 20px;
    @media screen and (max-width: 768px){
      font-size: 18px;
    }
    font-weight: bold;
    text-align: left;
    margin-bottom: 12px;
  }

  .carts-contents {
    padding: 10px;
    border: 1px solid #D8D8D8;
    border-radius: 4px;
    text-align: left;
    background: #fff;
    margin-bottom: 15px;
  }

  .carts-person {
    display: flex;
    @media screen and (max-width: 768px){
      display: block;
    }
    &__contents {
      width: 36%;
      @media screen and (max-width: 768px){
        margin-bottom: 10px;
        width: auto;
      }
    }
  }

  .person-info {
    &__ttl {
      font-size: 16px;
      display: flex;
      align-items: flex-end;
      font-weight: bold;
      margin-bottom: 5px;
      a {
        color: #FF5B60;
        font-size: 12px;
        font-weight: normal;
        margin-left: 10px;
      }
    }
    &__sentence {
      font-size: 12px;
    }
  }

  .person-payment {
    padding: 4px 6px;
    border: 1px solid #D8D8D8;
    border-radius: 4px;
    display: block;
    margin-bottom: 10px;
    max-width: 360px;
    &:hover {
      text-decoration: none;
      border-color: #FF5B60;
      background: rgb(255, 249, 249);
    }
    &.is-active {
      border-color: #FF5B60;
      background: rgb(255, 249, 249);
    }
    &__ttl {
      font-weight: bold;
      font-size: 12px;
    }
    &__sentence {
      font-size: 12px;
    }
  }

  .person-payment-card {
    display: flex;
    align-items: center;
    &__icon {
      margin-right: 3px;
      display: flex;
      align-items: center;
    }
    &__sentence {
      font-size: 12px;
    }
  }

  .scheduled-date-title {
    font-weight: bold;
    font-size: 16px;
    color: #FF5B60;
  }

  .order-area {
    padding: 10px;
    border: 1px solid #D8D8D8;
    border-radius: 4px;
    text-align: left;
    background: #fff;
    &__submit {
      margin-bottom: 10px;
      .btn-square {
        margin: 0 auto;
        height: 30px;
        @media screen and (max-width: 768px){
          width: 240px;
        }
      }
    }
  }

  .order-main {
    &__ttl {
      font-weight: bold;
    }
  }

  .order-detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .order-sum {
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #D8D8D8;
    font-size: 16px;
    &__price {
      color: #FF5B60;
    }
  }


</style>


// WEBPACK FOOTER //
// src/components/carts/Confirm.vue